import { Component, OnInit, ChangeDetectionStrategy, Input, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-embed-ig',
  templateUrl: './embed-ig.component.html',
  styleUrls: ['./embed-ig.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmbedIgComponent implements OnInit {

  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private _document) { }

  @Input() url: string;

  ngOnInit() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://www.instagram.com/embed.js';
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);
  }

}
